module.exports = __webpack_public_path__ + "static/media/coffee-min.97f5724e.png";